import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "../../../components/admin-layout";
import List from "./List";
import Edit from "./Edit";

export default function NativeClientPlatformPlans() {
    return (
        <Routes>
            <Route index element={
                <AdminLayout noPadding withBackground={false}>
                    <List />
                </AdminLayout>
            } />
            <Route path="create" element={
                <AdminLayout>
                    <Edit />
                </AdminLayout>
            } />
            <Route path=":id" element={
                <AdminLayout>
                    <Edit />
                </AdminLayout>
            } />
        </Routes>
    );
}
